import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/companies";

export default class CompanyService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
